import React from "react";
import { motion } from "framer-motion";
import SectionHead from "../SectionHead";
import { Section } from "./common";
import { container, item, inView, numRe } from "./presets";

const T = (dir, ar, en) => (dir === "rtl" ? ar : en);
const num = (i) => String(i + 1).padStart(2, "0");

function splitSteps(group) {
  const intro = group.nodes.filter((n) => n.t === "p" && !numRe.test(n.v));
  const steps = group.nodes.filter((n) => n.t === "p" && numRe.test(n.v)).map((n) => n.v.replace(numRe, ""));
  return { intro: intro[0] ? intro[0].v : undefined, steps };
}

/* ---------- Variant: Vertical connected timeline ---------- */
function StepsTimeline({ group, dark, dir }) {
  const { intro, steps } = splitSteps(group);
  return (
    <Section dark={dark}>
      <SectionHead tag={T(dir, "منهجيتنا", "Our process")} title={group.title} desc={intro} />
      <motion.div {...inView} variants={container} className="mt-12 max-w-3xl mx-auto relative">
        <span className="absolute top-3 bottom-3 w-px bg-[color:var(--rq-border)]" style={{ insetInlineStart: "23px" }} />
        <div className="grid gap-5">
          {steps.map((s, i) => (
            <motion.div key={i} variants={item} whileHover={{ x: dir === "rtl" ? -6 : 6 }} className="relative flex items-start gap-5">
              <span className="relative z-10 grid place-items-center h-12 w-12 rounded-full text-white font-display font-bold shrink-0" style={{ background: "linear-gradient(135deg,#0b5e2e,#14a24b)" }}>{num(i)}</span>
              <div className="rq-card p-5 md:p-6 flex-1">
                <p className="text-sm md:text-[15px] leading-relaxed text-[color:var(--rq-muted)]">{s}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </Section>
  );
}

/* ---------- Variant: Horizontal stepper ---------- */
function StepsStepper({ group, dark, dir }) {
  const { intro, steps } = splitSteps(group);
  return (
    <Section dark={dark}>
      <SectionHead tag={T(dir, "منهجيتنا", "Our process")} title={group.title} desc={intro} center />
      <motion.div {...inView} variants={container} className="mt-14 flex flex-col md:flex-row md:items-start md:justify-between gap-8 md:gap-0">
        {steps.map((s, i) => (
          <motion.div key={i} variants={item} className="md:flex-1 relative flex md:flex-col items-center md:text-center gap-4 md:gap-5 md:px-3 group">
            {i > 0 && (
              <span className="hidden md:block absolute top-7 h-px bg-[color:var(--rq-border)]" style={{ width: "100%", insetInlineStart: "-50%", zIndex: 0 }} />
            )}
            <span className="relative z-10 grid place-items-center h-14 w-14 rounded-2xl text-white font-display font-bold text-lg transition-transform duration-300 group-hover:scale-110 shrink-0" style={{ background: "linear-gradient(135deg,#0b5e2e,#14a24b)" }}>{num(i)}</span>
            <p className="text-sm leading-relaxed text-[color:var(--rq-muted)] md:max-w-[220px]">{s}</p>
          </motion.div>
        ))}
      </motion.div>
    </Section>
  );
}

export function Steps({ variant, ...props }) {
  if (variant === "stepper") return <StepsStepper {...props} />;
  return <StepsTimeline {...props} />;
}
